module.exports = __webpack_public_path__ + "static/media/18-holes-shot-6.d3896ad8.jpg";